export default (search) =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}permissions/roles?q=${encodeURIComponent(search)}`)
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
